import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const RegisterPage = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [form, setForm] = useState({
    cellphone: "",
    email: "",
    password: "",
    confirm: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const formatCellphone = (value = "") => {
    const digits = value.replace(/\D/g, "").slice(0, 11);

    if (digits.length <= 2) {
      return digits ? `(${digits}` : "";
    }

    if (digits.length <= 7) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    }

    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({
      ...prev,
      [name]: name === "cellphone" ? formatCellphone(value) : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    if (form.password.length < 5) {
      setError("A senha deve ter no minimo 5 caracteres.");
      return;
    }
    if (form.password !== form.confirm) {
      setError("As senhas nao coincidem.");
      return;
    }
    setLoading(true);
    try {
      await register(form.email, form.password);
      navigate("/empresa");
    } catch (err) {
      setError("Nao foi possivel criar sua conta. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-grid fade-in">
        <div className="auth-hero">
          <span className="eyebrow">Shopalli</span>
          <h2>Ative seu cadastro e anuncie seus produtos.</h2>
          <p>
            Complete o onboarding juridico e libere sua vitrine de anuncios
            segmentados.
          </p>
          <ul className="auth-highlights">
            <li>Cadastro rapido com email corporativo.</li>
            <li>Controle de documentos KYB.</li>
            <li>Segmentacao por publico-alvo.</li>
          </ul>
        </div>
        <div className="auth-card">
          <h1>Crie sua conta</h1>
          <p>Cadastre sua empresa e comece a anunciar na Shopalli.</p>
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label className="label">Celular</label>
              <input
                className="input"
                name="cellphone"
                type="tel"
                value={form.cellphone}
                onChange={handleChange}
                placeholder="(00) 00000-0000"
                inputMode="numeric"
                required
              />
            </div>
            <div className="field">
              <label className="label">E-mail corporativo</label>
              <input
                className="input"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="contato@empresa.com.br"
                required
              />
            </div>
            <div className="field">
              <label className="label">Senha</label>
              <input
                className="input"
                name="password"
                type="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Crie uma senha segura"
                minLength={5}
                required
              />
            </div>
            <div className="field">
              <label className="label">Confirmar senha</label>
              <input
                className="input"
                name="confirm"
                type="password"
                value={form.confirm}
                onChange={handleChange}
                placeholder="Repita a senha"
                required
              />
            </div>
            {error ? <div className="alert">{error}</div> : null}
            <button className="button button--primary" type="submit" disabled={loading}>
              {loading ? "Criando..." : "Criar conta"}
            </button>
          </form>
          <p className="muted">
            Ja tem conta? <Link to="/login">Entrar</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
